import ServiceTokensApi from '@/api/service-tokens'

const serviceTokens = {
  namespaced: true,
  state: {
    isLoading: false,
  },
  mutations: {
    setLoading(state, loading) {
      state.isLoading = loading
    },
  },
  actions: {
    async revokeAllTokens({ commit }) {
      commit('setLoading', true)
      try {
        const response = await ServiceTokensApi.revokeAllTokens()
        return response
      } catch (error) {
        console.error(error)
        throw error
      } finally {
        commit('setLoading', false)
      }
    },
  },
}

export default serviceTokens
